export type LinkableSearchFields = {
  reference?: string | null;
  title?: string | null;
  customerName?: string | null;
  customerFirstName?: string | null;
  customerLastName?: string | null;
  type?: string | null;
  kind?: string | null;
};

function normalize(value?: string | null) {
  return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
}

export function matchesLinkableSearch(doc: LinkableSearchFields, query: string): boolean {
  const q = normalize(query);
  if (!q) return true;

  const fullName = [doc.customerFirstName, doc.customerLastName].filter(Boolean).join(' ');
  const haystack = normalize([
    doc.reference,
    doc.title,
    doc.customerName,
    doc.customerFirstName,
    doc.customerLastName,
    fullName,
    doc.type,
    doc.kind,
  ].filter(Boolean).join(' '));

  if (haystack.includes(q)) return true;
  return q.split(' ').filter(Boolean).every((part) => haystack.includes(part));
}
